import { render, staticRenderFns } from "./CardKangarooGrass.vue?vue&type=template&id=cb106c42&"
import script from "./CardKangarooGrass.vue?vue&type=script&lang=js&"
export * from "./CardKangarooGrass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports